"use client";

import { useSyncExternalStore } from "react";
import {
  DEFAULT_THEME_PREFERENCE,
  THEME_CHANGE_EVENT,
  THEME_STORAGE_KEY,
  readRenderedTheme,
  readThemePreference,
  subscribeRenderedTheme,
  type RenderedTheme,
  type ThemePreference,
} from "@/lib/theme/app-theme";

function subscribeThemePreference(onChange: () => void): () => void {
  const onStorage = (event: StorageEvent) => {
    if (event.key === THEME_STORAGE_KEY) onChange();
  };
  window.addEventListener(THEME_CHANGE_EVENT, onChange);
  window.addEventListener("storage", onStorage);
  return () => {
    window.removeEventListener(THEME_CHANGE_EVENT, onChange);
    window.removeEventListener("storage", onStorage);
  };
}

export function useThemePreference(): ThemePreference {
  return useSyncExternalStore(subscribeThemePreference, readThemePreference, () => DEFAULT_THEME_PREFERENCE);
}

export function useRenderedTheme(): RenderedTheme {
  return useSyncExternalStore(subscribeRenderedTheme, readRenderedTheme, () => "light");
}
